import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './estilos/sistema-diseno.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// El tema base es oscuro. Se aplica la preferencia guardada antes del
// primer render para que no haya destello de tema al cargar.
try {
    if (localStorage.getItem('temaClaro') === 'true') {
        document.body.classList.add('tema-claro');
    }
    document.body.classList.remove('dark-mode');
} catch (e) {
    // Modo privado o almacenamiento bloqueado: se queda el tema oscuro.
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();